import { React, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { DataTable } from 'components';
import clsx from 'clsx';
import moment from 'moment';
import { SetSelectedSarpSites } from '../actions/SarpReportActions';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		padding: 0,
	},
	inner: {
		minWidth: 700,
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	actions: {
		padding: theme.spacing(1),
		justifyContent: 'flex-end',
	},
	primaryButton: {
		color: theme.palette.primary.main
	},
	errorButton: {
		color: theme.palette.error.main
	},
	infoButton: {
		color: theme.palette.info.main
	}
}));

const SarpSiteTable = (props) => {
	const { className, data, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const selectedSarpSites = useSelector((state) => state.sarpReportReducer.selectedSarpSites);

	const _handleChange = (option) => {		
		dispatch(SetSelectedSarpSites(option));
	};
	
	const _getTableColumns = () => (
		[
			{
				name: 'key',
				label: 'Key',
				options: {
					display: false,
					filterType: 'textField',
					customFilterListOptions: {
						render: v => `Key - ${v}`
					},
				}
			},
			{
				name: 'siteId',
				label: 'Site ID',
				options: {
					display: true,
					filterType: 'dropdown',
					customFilterListOptions: {
						render: v => `Site ID - ${v}`
					},
				}
			},
			{
				name: 'sow',
				label: 'SOW',
				options: {
					display: true,
					filterType: 'dropdown',
					customFilterListOptions: {
						render: v => `SOW - ${v}`
					},
				}
			},
			{
				name: 'commissioningDate',
				label: 'Commissioning Date',
				options: {
					display: true,
					filterType: 'textField',
					customFilterListOptions: {
						render: v => `Commissioning Date - ${v}`
					},
					customBodyRender: (value, tableMeta, updateValue) => <>{value === null ? '' : moment(value).format('DD-MM-YYYY').toString()}</>
				}
			},
			{
				name: 'commissioningOwner',
				label: 'Commissioning Owner',
				options: {
					display: true,
					filterType: 'textField',
					customFilterListOptions: {
						render: v => `Commissioning Owner - ${v}`
					},
				}
			}
		]
	);

	const options = {
		selectableRowsHeader: false, // Remove a checkbox do cabeçalho
	};

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<DataTable
				id="siteDataTable"
				title=""
				data={data}
				columns={_getTableColumns()}
				rowsPerPage={20}
				tableBodyMaxHeight="30em"
				tableBodyCellMaxWidth="250"
				selectableRows
				onRowSelection={(value) => _handleChange(value)}
				options = {options}
			/>
		</div>
	);
};

SarpSiteTable.propTypes = {
	className: PropTypes.string,
	data: PropTypes.array.isRequired,
};

export default SarpSiteTable;
